import Vue from 'vue'
export default new Vue({
  methods: {
    _confirm(
      msg,
      title = '提示',
      confirmBtn = '确定',
      cancelBtn = '取消',
      type = 'warning'
    ) {
      return this.$confirm(msg, title, {
        confirmButtonText: confirmBtn,
        cancelButtonText: cancelBtn,
        type: type
      })
    },
    _message(message, type = 'success') {
      this.$message({
        type: type,
        message: message
      })
    },
    _success(msg) {
      this.$message({
        type: 'success',
        message: msg
      })
    },
    _info(msg) {
      this.$message({
        type: 'info',
        message: msg
      })
    },
    _warn(msg) {
      this.$message({
        message: msg,
        type: "warning"
      });
    },
    _notify_success(msg, title = "成功") {
      notify.call(this, {
        msg,
        title,
        type: 'success'
      })
    },
    _notify_warn(msg, title = "提示") {
      notify.call(this, {
        msg,
        title,
        type: 'warning'
      })
    }
  }
})

function notify({
  title,
  msg,
  type,
  position
}) {
  this.$notify({
    title,
    message: msg,
    type,
    position
  })
}